var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "select",
    {
      staticClass: "form-control",
      domProps: { value: _vm.value },
      on: {
        change: function($event) {
          return _vm.$emit("input", $event.target.value)
        }
      }
    },
    _vm._l(_vm.options, function(option) {
      return _c(
        "option",
        { key: option.value, domProps: { value: option.value } },
        [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t(
                  "cell.print.qr.labelOptions." + _vm.camelCase(option.name)
                )
              ) +
              "\n  "
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }